import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { NotificationLines } from 'store/notification/enum';

import type { Notification } from 'Notification-Types';

import { clearNotification, setNotification } from './actions';

export const item = createReducer({
  isOpen: false,
  context: null,
  callback: () => {},
  lines: NotificationLines.SINGLE,
} as Notification)
  .handleAction(setNotification, (_state, action) => action.payload)
  .handleAction(clearNotification, (_state, _action) => {
    return {
      isOpen: false,
      context: null,
      callback: undefined,
      icon: undefined,
      lines: NotificationLines.SINGLE,
    };
  });

const notificationReducer = combineReducers({
  item,
});

export default notificationReducer;
export type NotificationState = ReturnType<typeof notificationReducer>;
